import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  addressFirstValidatorList,
  addressSecondValidatorList,
  addressThirdValidatorList,
  firstNameValidatorList,
  lastNameValidatorList,
  phoneFirstValidatorList,
  phoneSecondValidatorList,
  phoneThirdValidatorList,
  postalCodeFirstValidatorList,
  postalCodeSecondValidatorList
} from 'src/app/validators';
import { ADDRESS_1_ERROR, ADDRESS_2_ERROR, ADDRESS_3_ERROR, NAME_ERROR, PHONE_ERROR, POSTAL_CODE_ERROR, REQUIRED_ERROR } from 'src/app/validators.constants';
import Regions from 'src/app/data/regions';
import { MediaService } from 'app/services/media.service';

@Component({
  selector: 'app-form-shipping-address',
  templateUrl: './form-shipping-address.component.html',
  styleUrls: ['./form-shipping-address.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormShippingAddressComponent implements OnInit {
  @Input() set active(status: boolean) {
    if (this.active !== status) {
      this.activeFormControl.setValue(status);
    }
  }

  get active(): boolean {
    return this.activeFormControl.value;
  }

  @Output() activeChange = new EventEmitter<boolean>();

  @Input() data: any;

  @Output() dataChange = new EventEmitter<any>();

  public NAME_ERROR = NAME_ERROR
  public ADDRESS_1_ERROR = ADDRESS_1_ERROR
  public ADDRESS_2_ERROR = ADDRESS_2_ERROR
  public ADDRESS_3_ERROR = ADDRESS_3_ERROR
  public REQUIRED_ERROR = REQUIRED_ERROR
  public POSTAL_CODE_ERROR = POSTAL_CODE_ERROR
  public PHONE_ERROR = PHONE_ERROR

  public regions = Regions

  public activeFormControl = new FormControl(true);

  public formGroup: FormGroup = new FormGroup({
    // name
    lastName: new FormControl('', lastNameValidatorList),
    firstName: new FormControl('', firstNameValidatorList),
    // postal code
    postalCodeFirst: new FormControl('', postalCodeFirstValidatorList),
    postalCodeSecond: new FormControl('', postalCodeSecondValidatorList),
    // address
    addressFirst: new FormControl('', addressFirstValidatorList),
    addressSecond: new FormControl('', addressSecondValidatorList),
    addressThird: new FormControl('', addressThirdValidatorList),
    // phone
    phoneFirst: new FormControl('', phoneFirstValidatorList),
    phoneSecond: new FormControl('', phoneSecondValidatorList),
    phoneThird: new FormControl('', phoneThirdValidatorList),
  })

  constructor(
    public media: MediaService,
  ) { }

  ngOnInit(): void {
    this.formGroup.valueChanges.subscribe((data) => {
      this.onChange(data);
    })

    this.activeFormControl.valueChanges.subscribe((status) => {
      this.activeChange.emit(status);
    })
  }

  onChange(data: any) {
    this.dataChange.emit(data);
  }
}
